export const environment = {
    appName: 'Demand Flexibility Service',
    appUrl: 'https://dev.flexibility.perse.io',

    production: true,
    environment: 'dev',
    whiteLabel: null,
    logo: 'https://s3.eu-west-1.amazonaws.com/assets.perse.io/perse_logos/perse_green_with_text.svg', // TODO:: Change the URL
    logoStyle: 'height: auto;',
    header: 'Join the 1.6m households and businesses being',
    primaryHeader: '',
    highlightHeader: 'paid to save energy.',
    description: 'You could earn between £500 and £50,000 and it’s free to participate.',
  
    //Login endpoint
    loginUrl: 'https://dev.flexibility.perse.io/auth?link=',
    //loginUrl: 'http://localhost:4200/auth?link=',
    loginSubject: 'Perse DFS login',
  
    // API endpoints
    baseUrl: '/api',
    eApiKey: 'U2FsdGVkX192qixrCGGatPyyOZ5JgJlfXxYWqyouY86AVVRAkktVgOiAwm93hdkGaX/DbFqO5qeqcE9+ael15g==',
    apiKey: 'PERSE-TEST-CLIENT-APIKEY-0fcac2975984',

    // AWS Cognito Configuration
    cognito: {
      userPoolId: 'eu-west-1_5rgLQWu6I',
      userPoolClientId: '67vrlkl5eicdv9bc8qq9gutoll',
      region: 'eu-west-1',
    },

    faqs: [
      {
        question: 'What is the Demand Flexibility Service (DFS)?',
        answer: [
          {
            type: 'p',
            text: 'The Demand Flexibility Service (DFS) is an Ofgem (energy regulator) approved programme that gives financial rewards to home and businesses for reducing their electricity usage in peak demand periods.',
          },
          {
            type: 'p',
            text: 'The National Energy System Operator (NESO) is constantly needing to balance electricity generation and supply, with electricity demand. Peak demand periods are usually between 4pm-7pm, which is when people are home and cooking dinner, watching TV, and using other appliances. Demand can be higher than the electricity available in these times, such as when there is a big event being televised or due to weather conditions. It’s typically run over the winter months as this is when electricity can be in shorter supply, either due to there being an unexpected drop in wind which reduces renewable energy generation; or, there is a sudden reduction in gas supplies, due to people turning up their heating — whilst DFS relates to electricity only, gas is used to generate electricity from sources other than renewable energy ones.',
          },
        ],
      },
      {
        question: 'Who are the National Energy System Operator?',
        answer: [
          {
            type: 'p',
            text: 'The NESO is the energy system operator for Great Britain. They move electricity around Great Britain’s system to keep homes and businesses supplied with the energy they need 24/7, 365 days a year. They don’t generate or sell electricity, just balance the grid. The NESO is regulated by Ofgem.',
          },
        ],
      },
      {
        question: 'Where does the money come from that I can earn?',
        answer: [
          {
            type: 'p',
            text: 'Monies are paid by the NESO and are generated from savings in being able to balance the grid more efficiently. The alternatives to paying people to use less energy in peak periods are to:',
          },
          {
            type: 'ul',
            text: [
              'Pay for more energy generation, which at the last minute and in an emergency, costs a lot more than standard generation;',
              'Impose financial penalties on energy suppliers for not predicting their customers’ energy usage more accurately, with fines tending to ultimately be passed down onto customer bills.',
            ],
          },
          {
            type: 'p',
            text: 'Alternative, last minute, additional energy generation also tends to be more carbon intensive energy. In the future, this may add an additional cost to offset or later capture that carbon, in order to meet net zero targets.',
          },
        ],
      },
      {
        question: 'What does Perse provide in relation to this service?',
        answer: [
          {
            type: 'p',
            text: 'Perse is an approved Registered Supplier which means we can facilitate the participation of homes and businesses to take part. What this means is that we offer you the ability to create an account and receive relevant communications, we then process the data required to predict and reconcile electricity savings and monies due. Finally, we process the payments from the NESO to you.',
          },
          {
            type: 'p',
            text: 'Registered Suppliers undergo a series of checks with the NESO before they are approved. Perse is also compliant with Homeflex Code of Conduct for households and the Flex Assure Code of Conduct for businesses.',
          },
        ],
      },
      {
        question: 'Why choose Perse rather than my energy supplier?',
        answer: [
          {
            type: 'p',
            text: 'The main benefit of signing up with Perse is that we pay cash for participation rather than points or other redeemable benefits. This ensures we provide total transparency of the value being passed back to you. Plus, most people prefer cash to decide how to spend it without restriction.',
          },
          {
            type: 'p',
            text: 'The other benefit is that you do not need to be with any specific energy supplier. Not all energy suppliers currently support this Service and so it’s crucial that independent services like us exist to ensure everyone can benefit.',
          },
        ],
      },
      {
        question: 'What are the eligibility requirements?',
        answer: [
          {
            type: 'p',
            text: 'All participants',
          },
          {
            type: 'p',
            text: 'You need to be over 18 years of age and have your premises in Britain. You can only be signed up to one Registered Provider at a time. If you have registered more than once, it will be the Provider you joined most recently which will provide the Service. It does not matter which energy supplier you’re with.',
          },
          {
            type: 'p',
            text: 'Homes',
          },
          {
            type: 'p',
            text: 'If you’re a household, you need a smart electricity meter that meets the SMETS technical specifications and is currently operational. We can tell you if you meet these requirements, only needing your address in order to do so.',
          },
          {
            type: 'p',
            text: 'Businesses',
          },
          {
            type: 'p',
            text: 'If you’re a business, you need either a smart electricity meter that meets the SMETS technical specifications and is currently operational; or, a half hourly settled meter. Again, we can tell you if you meet these requirements, only needing your address in order to do so.',
          },
          {
            type: 'p',
            text: 'You also can be operating in any other services, including trials, such as Short-Term Operating Reserve (STOR) or Frequency Response, the Capacity Mechanism, or DNO/DSO services at the same time.',
          },
        ],
      },
      {
        question: 'What are the benefits of participating?',
        answer: [
          {
            type: 'p',
            text: 'The main benefit is to earn money. Unlike some other Service Providers, we transfer cash not points or other redeemable rewards.',
          },
          {
            type: 'p',
            text: 'You also have the benefit of helping save carbon and helping to reduce overall market costs. These sorts of services do have the potential to ensure we have a more affordable and secure supply of energy for everyone.',
          },
        ],
      },
      {
        question: 'How much money can I expect to earn?',
        answer: [
          {
            type: 'p',
            text: 'This will depend on how much electricity you can reduce. It is estimated that businesses could earn between £500 to £50,000, as outlined by CUB(UK), one of the energy consultancies that we work with.',
          },
          {
            type: 'p',
            text: 'Last year, some households earned more than £100. Of course, earnings correlate not only to how much electricity is saved in an event, but also how many events you participate in.',
          },
        ],
      },
      {
        question: 'How many events will there be?',
        answer: [
          {
            type: 'p',
            text: 'This winter 2023/24, there will be a minimum of 12 one-hour tests. 6 tests will be in November and December. 6 tests will run between January and March. In addition, there is likely to be additional live events depending on the need for them.',
          },
          {
            type: 'p',
            text: 'Last year, there were 10 tests and 2 live events. Live events went for up to 3 hours and tended to be between 4pm-7pm.',
          },
        ],
      },
      {
        question: 'How can I reduce electricity consumption during an event?',
        answer: [
          {
            type: 'p',
            text: 'Households can avoid running power-hungry appliances. These include washing machines, clothes dryers, dishwashers, electric showers and immersion heaters. You can also choose between appliances that use less electricity, such as choosing to use a microwave over an electric oven.',
          },
          {
            type: 'p',
            text: 'For businesses, it can depend on the nature of your business. But some ideas are to introduce staff breaks, reduce cold storage use, turn off air conditioning or electric heating, plus pre-charging and then using batteries.',
          },
        ],
      },
      {
        question: 'Does it cost money to participate?',
        answer: [
          {
            type: 'p',
            text: 'It is free to participate. However, we take a transaction fee for providing the service. For example, if the NESO was paying £3 per 1 kilowatt of electricity saved, you would be paid £2.10 and Perse would be paid £0.90.',
          },
        ],
      },
      {
        question: 'What if I sign up but don’t end up saving any energy?',
        answer: [
          {
            type: 'p',
            text: 'There is no penalty for signing up to an event but not actually managing to save any electricity. Nor is there a penalty for saving more than what is estimated. So you have nothing to lose to register, only bonus cash if you do save.',
          },
        ],
      },
      {
        question: 'What are your savings and payment projections based on?',
        answer: [
          {
            type: 'p',
            text: 'We obtain your industry information which includes your historical usage in half hourly intervals. We then create a baseline of your electricity consumption over a week period in 30 minute intervals. We update that baseline according to the 10 day period before each event. We submit to the NESO a forecast of how much electricity we believe you may save based on the assumption that you will reduce this baseline by 50% or by whatever amount you notify us of. After the event, we then compare that with the data of what you actually used. Remember, there is no penalty for using more or less than the estimate. But you will only be paid what you actually reduce.',
          },
          {
            type: 'p',
            text: 'If your usage has significantly changed in the last year, or even more recently, it is best to let us know as this will impact our projections.',
          },
          {
            type: 'p',
            text: 'Obviously, we can only estimate and cannot guarantee how much electricity you will reduce. This will always be within your control.',
          },
        ],
      },
      {
        question: 'What happens step by step in a DFS Event?',
        answer: [
          {
            type: 'p',
            text: 'We will give you advance notice of each event - 24 hours beforehand and then again in the morning or afternoon of the event, depending on the time of it.',
          },
          {
            type: 'p',
            text: 'Within 7 days of an event, we will update your account with how much electricity you have saved and how much money you have earned. However, this is still subject to acceptance by the NESO and their decision is final. The NESO is likely to confirm savings within 21 days of an event. Payment is then likely to be made available via your account 7 days later. You will need to withdraw a minimum of £5 at a time from your account. If you have less than this at the end of all events this winter, you will be able to withdraw all remaining sums without a minimum applying.',
          },
        ],
      },
      {
        question: 'How long does it take to get paid?',
        answer: [
          {
            type: 'p',
            text: 'As above, between event end and payment being eligible from your account, this should be within 3-6 weeks. Once you have requested payment, it may then take an additional 5 working days.',
          },
        ],
      },
      {
        question: 'How can I speak to someone for more information?',
        answer: [
          {
            type: 'p',
            text: 'There is a lot more information on the NESO website which you can find here: https://www.neso.org.uk/',
          },
          {
            type: 'p',
            text: 'You can also email us at contact@perse.energy.',
          },
        ],
      },
    ],
  };
  